<ad-detail-plain-tag>
    <h2 class="heading-03 margin-spacing-2_bottom margin-spacing-4_top">
        {props.item.title}
    </h2>
    <ul class="scope_list margin-spacing-2_bottom">
        <li class="scope_list-item" each="{ title in props.item.items }">
            <span class="skill_label">{ title }</span>
        </li>
    </ul>
    <script>
        export default {
            onMounted(props, state) {
            }
        }
    </script>
</ad-detail-plain-tag>
